const PREDICTORS_VALUES = [
  "/arts_&_entertainment",
  "/arts_&_entertainment/celebrities_&_entertainment_news",
  "/arts_&_entertainment/comics_&_animation",
  "/arts_&_entertainment/comics_&_animation/anime_&_manga",
  "/arts_&_entertainment/comics_&_animation/cartoons",
  "/arts_&_entertainment/comics_&_animation/comics",
  "/arts_&_entertainment/entertainment_industry",
  "/arts_&_entertainment/entertainment_industry/film_&_tv_industry",
  "/arts_&_entertainment/entertainment_industry/recording_industry",
  "/arts_&_entertainment/events_&_listings",
  "/arts_&_entertainment/events_&_listings/bars_clubs_&_nightlife",
  "/arts_&_entertainment/events_&_listings/concerts_&_music_festivals",
  "/arts_&_entertainment/events_&_listings/event_ticket_sales",
  "/arts_&_entertainment/events_&_listings/expos_&_conventions",
  "/arts_&_entertainment/events_&_listings/film_festivals",
  "/arts_&_entertainment/events_&_listings/food_&_beverage_events",
  "/arts_&_entertainment/events_&_listings/live_sporting_events",
  "/arts_&_entertainment/events_&_listings/movie_listings_&_theater_showtimes",
  "/arts_&_entertainment/fun_&_trivia",
  "/arts_&_entertainment/fun_&_trivia/flash-based_entertainment",
  "/arts_&_entertainment/fun_&_trivia/fun_tests_&_silly_surveys",
  "/arts_&_entertainment/humor",
  "/arts_&_entertainment/humor/funny_pictures_&_videos",
  "/arts_&_entertainment/humor/live_comedy",
  "/arts_&_entertainment/humor/political_humor",
  "/arts_&_entertainment/humor/spoofs_&_satire",
  "/arts_&_entertainment/movies",
  "/arts_&_entertainment/movies/action_&_adventure_films",
  "/arts_&_entertainment/movies/animated_films",
  "/arts_&_entertainment/movies/bollywood_&_south_asian_film",
  "/arts_&_entertainment/movies/classic_films",
  "/arts_&_entertainment/movies/comedy_films",
  "/arts_&_entertainment/movies/cult_&_indie_films",
  "/arts_&_entertainment/movies/documentary_films",
  "/arts_&_entertainment/movies/drama_films",
  "/arts_&_entertainment/movies/dvd_&_video_shopping",
  "/arts_&_entertainment/movies/family_films",
  "/arts_&_entertainment/movies/horror_films",
  "/arts_&_entertainment/movies/movie_memorabilia",
  "/arts_&_entertainment/movies/movie_reference",
  "/arts_&_entertainment/movies/musical_films",
  "/arts_&_entertainment/movies/romance_films",
  "/arts_&_entertainment/movies/science_fiction_&_fantasy_films",
  "/arts_&_entertainment/movies/thriller_crime_&_mystery_films",
  "/arts_&_entertainment/music_&_audio",
  "/arts_&_entertainment/music_&_audio/cd_&_audio_shopping",
  "/arts_&_entertainment/music_&_audio/classical_music",
  "/arts_&_entertainment/music_&_audio/country_music",
  "/arts_&_entertainment/music_&_audio/dance_&_electronic_music",
  "/arts_&_entertainment/music_&_audio/experimental_&_industrial_music",
  "/arts_&_entertainment/music_&_audio/folk_&_traditional_music",
  "/arts_&_entertainment/music_&_audio/jazz_&_blues",
  "/arts_&_entertainment/music_&_audio/music_art_&_memorabilia",
  "/arts_&_entertainment/music_&_audio/music_education_&_instruction",
  "/arts_&_entertainment/music_&_audio/music_equipment_&_technology",
  "/arts_&_entertainment/music_&_audio/music_reference",
  "/arts_&_entertainment/music_&_audio/music_streams_&_downloads",
  "/arts_&_entertainment/music_&_audio/music_videos",
  "/arts_&_entertainment/music_&_audio/podcasts",
  "/arts_&_entertainment/music_&_audio/pop_music",
  "/arts_&_entertainment/music_&_audio/radio",
  "/arts_&_entertainment/music_&_audio/religious_music",
  "/arts_&_entertainment/music_&_audio/rock_music",
  "/arts_&_entertainment/music_&_audio/soundtracks",
  "/arts_&_entertainment/music_&_audio/urban_&_hip-hop",
  "/arts_&_entertainment/music_&_audio/vocals_&_show_tunes",
  "/arts_&_entertainment/music_&_audio/world_music",
  "/arts_&_entertainment/offbeat",
  "/arts_&_entertainment/offbeat/occult_&_paranormal",
  "/arts_&_entertainment/online_media",
  "/arts_&_entertainment/online_media/online_image_galleries",
  "/arts_&_entertainment/online_media/webcams_&_virtual_tours",
  "/arts_&_entertainment/performing_arts",
  "/arts_&_entertainment/performing_arts/acting_&_theater",
  "/arts_&_entertainment/performing_arts/broadway_&_musical_theater",
  "/arts_&_entertainment/performing_arts/circus",
  "/arts_&_entertainment/performing_arts/dance",
  "/arts_&_entertainment/performing_arts/magic",
  "/arts_&_entertainment/performing_arts/opera",
  "/arts_&_entertainment/tv_&_video",
  "/arts_&_entertainment/tv_&_video/online_video",
  "/arts_&_entertainment/tv_&_video/tv_commercials",
  "/arts_&_entertainment/tv_&_video/tv_guides_&_reference",
  "/arts_&_entertainment/tv_&_video/tv_networks_&_stations",
  "/arts_&_entertainment/tv_&_video/tv_shows_&_programs",
  "/arts_&_entertainment/visual_art_&_design",
  "/arts_&_entertainment/visual_art_&_design/architecture",
  "/arts_&_entertainment/visual_art_&_design/art_&_craft_supplies",
  "/arts_&_entertainment/visual_art_&_design/art_museums_&_galleries",
  "/arts_&_entertainment/visual_art_&_design/arts_education",
  "/arts_&_entertainment/visual_art_&_design/design",
  "/arts_&_entertainment/visual_art_&_design/painting",
  "/arts_&_entertainment/visual_art_&_design/photographic_&_digital_arts",
  "/arts_&_entertainment/visual_art_&_design/sculpture",
  "/autos_&_vehicles",
  "/autos_&_vehicles/bicycles_&_accessories",
  "/autos_&_vehicles/bicycles_&_accessories/bike_accessories",
  "/autos_&_vehicles/bicycles_&_accessories/bike_frames",
  "/autos_&_vehicles/bicycles_&_accessories/bike_helmets_&_protective_gear",
  "/autos_&_vehicles/bicycles_&_accessories/bike_parts_&_repair",
  "/autos_&_vehicles/bicycles_&_accessories/bmx_bikes",
  "/autos_&_vehicles/bicycles_&_accessories/cruiser_bikes",
  "/autos_&_vehicles/bicycles_&_accessories/electric_bicycles",
  "/autos_&_vehicles/bicycles_&_accessories/kids_bikes",
  "/autos_&_vehicles/bicycles_&_accessories/mountain_bikes",
  "/autos_&_vehicles/bicycles_&_accessories/road_bikes",
  "/autos_&_vehicles/boats_&_watercraft",
  "/autos_&_vehicles/campers_&_rvs",
  "/autos_&_vehicles/classic_vehicles",
  "/autos_&_vehicles/commercial_vehicles",
  "/autos_&_vehicles/commercial_vehicles/cargo_trucks_&_trailers",
  "/autos_&_vehicles/custom_&_performance_vehicles",
  "/autos_&_vehicles/hybrid_&_alternative_vehicles",
  "/autos_&_vehicles/hybrid_&_alternative_vehicles/electric_&_plug-in_vehicles",
  "/autos_&_vehicles/microcars_&_city_cars",
  "/autos_&_vehicles/motor_vehicles_by_type",
  "/autos_&_vehicles/motor_vehicles_by_type/autonomous_vehicles",
  "/autos_&_vehicles/motor_vehicles_by_type/compact_cars",
  "/autos_&_vehicles/motor_vehicles_by_type/convertibles",
  "/autos_&_vehicles/motor_vehicles_by_type/coupes",
  "/autos_&_vehicles/motor_vehicles_by_type/diesel_vehicles",
  "/autos_&_vehicles/motor_vehicles_by_type/hatchbacks",
  "/autos_&_vehicles/motor_vehicles_by_type/luxury_vehicles",
  "/autos_&_vehicles/motor_vehicles_by_type/sedans",
  "/autos_&_vehicles/motor_vehicles_by_type/sports_cars",
  "/autos_&_vehicles/motor_vehicles_by_type/station_wagons",
  "/autos_&_vehicles/motorcycles",
  "/autos_&_vehicles/off-road_vehicles",
  "/autos_&_vehicles/personal_aircraft",
  "/autos_&_vehicles/scooters_&_mopeds",
  "/autos_&_vehicles/trucks_&_suvs",
  "/autos_&_vehicles/trucks_&_suvs/suvs",
  "/autos_&_vehicles/trucks_&_suvs/trucks",
  "/autos_&_vehicles/trucks_&_suvs/vans_&_minivans",
  "/autos_&_vehicles/vehicle_brands",
  "/autos_&_vehicles/vehicle_brands/acura",
  "/autos_&_vehicles/vehicle_brands/audi",
  "/autos_&_vehicles/vehicle_brands/bentley",
  "/autos_&_vehicles/vehicle_brands/bmw",
  "/autos_&_vehicles/vehicle_brands/buick",
  "/autos_&_vehicles/vehicle_brands/cadillac",
  "/autos_&_vehicles/vehicle_brands/chevrolet",
  "/autos_&_vehicles/vehicle_brands/chrysler",
  "/autos_&_vehicles/vehicle_brands/citroën",
  "/autos_&_vehicles/vehicle_brands/dodge",
  "/autos_&_vehicles/vehicle_brands/ferrari",
  "/autos_&_vehicles/vehicle_brands/fiat",
  "/autos_&_vehicles/vehicle_brands/ford",
  "/autos_&_vehicles/vehicle_brands/gm-daewoo",
  "/autos_&_vehicles/vehicle_brands/gmc",
  "/autos_&_vehicles/vehicle_brands/honda",
  "/autos_&_vehicles/vehicle_brands/hummer",
  "/autos_&_vehicles/vehicle_brands/hyundai",
  "/autos_&_vehicles/vehicle_brands/isuzu",
  "/autos_&_vehicles/vehicle_brands/jaguar",
  "/autos_&_vehicles/vehicle_brands/jeep",
  "/autos_&_vehicles/vehicle_brands/kia",
  "/autos_&_vehicles/vehicle_brands/lamborghini",
  "/autos_&_vehicles/vehicle_brands/land_rover",
  "/autos_&_vehicles/vehicle_brands/lexus",
  "/autos_&_vehicles/vehicle_brands/lincoln",
  "/autos_&_vehicles/vehicle_brands/maserati",
  "/autos_&_vehicles/vehicle_brands/mazda",
  "/autos_&_vehicles/vehicle_brands/mercedes-benz",
  "/autos_&_vehicles/vehicle_brands/mercury",
  "/autos_&_vehicles/vehicle_brands/mini",
  "/autos_&_vehicles/vehicle_brands/mitsubishi",
  "/autos_&_vehicles/vehicle_brands/nissan",
  "/autos_&_vehicles/vehicle_brands/peugeot",
  "/autos_&_vehicles/vehicle_brands/pontiac",
  "/autos_&_vehicles/vehicle_brands/porsche",
  "/autos_&_vehicles/vehicle_brands/ram_trucks",
  "/autos_&_vehicles/vehicle_brands/renault",
  "/autos_&_vehicles/vehicle_brands/rolls-royce",
  "/autos_&_vehicles/vehicle_brands/saab",
  "/autos_&_vehicles/vehicle_brands/saturn",
  "/autos_&_vehicles/vehicle_brands/seat",
  "/autos_&_vehicles/vehicle_brands/skoda",
  "/autos_&_vehicles/vehicle_brands/subaru",
  "/autos_&_vehicles/vehicle_brands/suzuki",
  "/autos_&_vehicles/vehicle_brands/tesla_motors",
  "/autos_&_vehicles/vehicle_brands/toyota",
  "/autos_&_vehicles/vehicle_brands/vauxhall-opel",
  "/autos_&_vehicles/vehicle_brands/volkswagen",
  "/autos_&_vehicles/vehicle_brands/volvo",
  "/autos_&_vehicles/vehicle_codes_&_driving_laws",
  "/autos_&_vehicles/vehicle_codes_&_driving_laws/drunk_driving_law",
  "/autos_&_vehicles/vehicle_codes_&_driving_laws/vehicle_&_traffic_safety",
  "/autos_&_vehicles/vehicle_codes_&_driving_laws/vehicle_licensing_&_registration",
  "/autos_&_vehicles/vehicle_maintenance",
  "/autos_&_vehicles/vehicle_parts_&_accessories",
  "/autos_&_vehicles/vehicle_parts_&_accessories/engine_&_transmission",
  "/autos_&_vehicles/vehicle_parts_&_accessories/vehicle_fuels_&_lubricants",
  "/autos_&_vehicles/vehicle_parts_&_accessories/vehicle_wheels_&_tires",
  "/autos_&_vehicles/vehicle_parts_&_services",
  "/autos_&_vehicles/vehicle_parts_&_services/towing_&_roadside_assistance",
  "/autos_&_vehicles/vehicle_parts_&_services/vehicle_modification_&_tuning",
  "/autos_&_vehicles/vehicle_shopping",
  "/autos_&_vehicles/vehicle_shopping/fuel_economy_&_gas_prices",
  "/autos_&_vehicles/vehicle_shopping/used_vehicles",
  "/autos_&_vehicles/vehicle_shopping/vehicle_dealers_&_retailers",
  "/autos_&_vehicles/vehicle_shopping/vehicle_specs_reviews_&_comparisons",
  "/autos_&_vehicles/vehicle_shows",
  "/beauty_&_fitness",
  "/beauty_&_fitness/beauty_pageants",
  "/beauty_&_fitness/body_art",
  "/beauty_&_fitness/cosmetic_procedures",
  "/beauty_&_fitness/cosmetic_procedures/cosmetic_surgery",
  "/beauty_&_fitness/cosmetology_&_beauty_professionals",
  "/beauty_&_fitness/face_&_body_care",
  "/beauty_&_fitness/face_&_body_care/clean_beauty",
  "/beauty_&_fitness/face_&_body_care/hygiene_&_toiletries",
  "/beauty_&_fitness/face_&_body_care/make-up_&_cosmetics",
  "/beauty_&_fitness/face_&_body_care/perfumes_&_fragrances",
  "/beauty_&_fitness/face_&_body_care/skin_&_nail_care",
  "/beauty_&_fitness/face_&_body_care/sun_care_&_tanning_products",
  "/beauty_&_fitness/face_&_body_care/unwanted_body_&_facial_hair_removal",
  "/beauty_&_fitness/fashion_&_style",
  "/beauty_&_fitness/fashion_&_style/fashion_designers_&_collections",
  "/beauty_&_fitness/fashion_&_style/fashion_modeling",
  "/beauty_&_fitness/fitness",
  "/beauty_&_fitness/fitness/bodybuilding",
  "/beauty_&_fitness/fitness/fitness_equipment_&_accessories",
  "/beauty_&_fitness/fitness/fitness_instruction_&_personal_training",
  "/beauty_&_fitness/fitness/gyms_&_health_clubs",
  "/beauty_&_fitness/fitness/high_intensity_interval_training",
  "/beauty_&_fitness/fitness/yoga_&_pilates",
  "/beauty_&_fitness/hair_care",
  "/beauty_&_fitness/hair_care/hair_loss",
  "/beauty_&_fitness/hair_care/shampoos_&_conditioners",
  "/beauty_&_fitness/spas_&_beauty_services",
  "/beauty_&_fitness/spas_&_beauty_services/manicures_&_pedicures",
  "/beauty_&_fitness/spas_&_beauty_services/massage_therapy",
  "/beauty_&_fitness/weight_loss",
  "/books_&_literature",
  "/books_&_literature/audiobooks",
  "/books_&_literature/book_retailers",
  "/books_&_literature/children's_literature",
  "/books_&_literature/childrens_literature",
  "/books_&_literature/e-books",
  "/books_&_literature/fan_fiction",
  "/books_&_literature/literary_classics",
  "/books_&_literature/magazines",
  "/books_&_literature/poetry",
  "/books_&_literature/writers_resources",
  "/business_&_industrial",
  "/business_&_industrial/advertising_&_marketing",
  "/business_&_industrial/advertising_&_marketing/brand_management",
  "/business_&_industrial/advertising_&_marketing/marketing",
  "/business_&_industrial/advertising_&_marketing/promotional_items_&_corporate_gifts",
  "/business_&_industrial/advertising_&_marketing/public_relations",
  "/business_&_industrial/advertising_&_marketing/sales",
  "/business_&_industrial/advertising_&_marketing/telemarketing",
  "/business_&_industrial/aerospace_&_defense",
  "/business_&_industrial/aerospace_&_defense/aviation_industry",
  "/business_&_industrial/aerospace_&_defense/defense_industry",
  "/business_&_industrial/aerospace_&_defense/space_technology",
  "/business_&_industrial/agriculture_&_forestry",
  "/business_&_industrial/agriculture_&_forestry/agricultural_equipment",
  "/business_&_industrial/agriculture_&_forestry/aquaculture",
  "/business_&_industrial/agriculture_&_forestry/crops_&_seed",
  "/business_&_industrial/agriculture_&_forestry/farms_&_ranches",
  "/business_&_industrial/agriculture_&_forestry/food_production",
  "/business_&_industrial/agriculture_&_forestry/forestry",
  "/business_&_industrial/agriculture_&_forestry/horticulture",
  "/business_&_industrial/agriculture_&_forestry/livestock",
  "/business_&_industrial/automotive_industry",
  "/business_&_industrial/business_education",
  "/business_&_industrial/business_finance",
  "/business_&_industrial/business_finance/commercial_lending",
  "/business_&_industrial/business_finance/investment_banking",
  "/business_&_industrial/business_finance/risk_management",
  "/business_&_industrial/business_finance/venture_capital",
  "/business_&_industrial/business_operations",
  "/business_&_industrial/business_operations/business_plans_&_presentations",
  "/business_&_industrial/business_operations/flexible_work_arrangements",
  "/business_&_industrial/business_operations/human_resources",
  "/business_&_industrial/business_operations/management",
  "/business_&_industrial/business_services",
  "/business_&_industrial/business_services/commercial_distribution",
  "/business_&_industrial/business_services/consulting",
  "/business_&_industrial/business_services/corporate_events",
  "/business_&_industrial/business_services/e-commerce_services",
  "/business_&_industrial/business_services/fire_&_security_services",
  "/business_&_industrial/business_services/knowledge_management",
  "/business_&_industrial/business_services/office_services",
  "/business_&_industrial/business_services/office_supplies",
  "/business_&_industrial/business_services/outsourcing",
  "/business_&_industrial/business_services/physical_asset_management",
  "/business_&_industrial/business_services/quality_control_&_tracking",
  "/business_&_industrial/business_services/shared_workspaces",
  "/business_&_industrial/business_services/signage",
  "/business_&_industrial/business_services/writing_&_editing_services",
  "/business_&_industrial/chemicals_industry",
  "/business_&_industrial/chemicals_industry/agrochemicals",
  "/business_&_industrial/chemicals_industry/cleaning_agents",
  "/business_&_industrial/chemicals_industry/coatings_&_adhesives",
  "/business_&_industrial/chemicals_industry/dyes_&_pigments",
  "/business_&_industrial/chemicals_industry/plastics_&_polymers",
  "/business_&_industrial/construction_&_maintenance",
  "/business_&_industrial/construction_&_maintenance/building_materials_&_supplies",
  "/business_&_industrial/construction_&_maintenance/civil_engineering",
  "/business_&_industrial/construction_&_maintenance/urban_&_regional_planning",
  "/business_&_industrial/energy_&_utilities",
  "/business_&_industrial/energy_&_utilities/electricity",
  "/business_&_industrial/energy_&_utilities/nuclear_energy",
  "/business_&_industrial/energy_&_utilities/oil_&_gas",
  "/business_&_industrial/energy_&_utilities/renewable_&_alternative_energy",
  "/business_&_industrial/energy_&_utilities/waste_management",
  "/business_&_industrial/energy_&_utilities/water_supply_&_treatment",
  "/business_&_industrial/hospitality_industry",
  "/business_&_industrial/hospitality_industry/event_planning",
  "/business_&_industrial/hospitality_industry/event_venue_rentals",
  "/business_&_industrial/hospitality_industry/food_service",
  "/business_&_industrial/industrial_materials_&_equipment",
  "/business_&_industrial/industrial_materials_&_equipment/fluid_handling",
  "/business_&_industrial/industrial_materials_&_equipment/generators",
  "/business_&_industrial/industrial_materials_&_equipment/heavy_machinery",
  "/business_&_industrial/industrial_materials_&_equipment/industrial_handling_&_processing_equipment",
  "/business_&_industrial/industrial_materials_&_equipment/industrial_measurement_&_control_equipment",
  "/business_&_industrial/manufacturing",
  "/business_&_industrial/manufacturing/factory_automation",
  "/business_&_industrial/metals_&_mining",
  "/business_&_industrial/metals_&_mining/precious_metals",
  "/business_&_industrial/pharmaceuticals_&_biotech",
  "/business_&_industrial/printing_&_publishing",
  "/business_&_industrial/printing_&_publishing/document_&_printing_services",
  "/business_&_industrial/retail_trade",
  "/business_&_industrial/retail_trade/retail_equipment_&_technology",
  "/business_&_industrial/small_business",
  "/business_&_industrial/small_business/business_formation",
  "/business_&_industrial/small_business/home_office",
  "/business_&_industrial/small_business/mlm_&_business_opportunities",
  "/business_&_industrial/textiles_&_nonwovens",
  "/business_&_industrial/transportation_&_logistics",
  "/business_&_industrial/transportation_&_logistics/aviation",
  "/business_&_industrial/transportation_&_logistics/distribution_&_logistics",
  "/business_&_industrial/transportation_&_logistics/freight_&_trucking",
  "/business_&_industrial/transportation_&_logistics/import_&_export",
  "/business_&_industrial/transportation_&_logistics/mail_&_package_delivery",
  "/business_&_industrial/transportation_&_logistics/maritime_transport",
  "/business_&_industrial/transportation_&_logistics/moving_&_relocation",
  "/business_&_industrial/transportation_&_logistics/packaging",
  "/business_&_industrial/transportation_&_logistics/parking",
  "/business_&_industrial/transportation_&_logistics/public_storage",
  "/business_&_industrial/transportation_&_logistics/rail_transport",
  "/business_&_industrial/transportation_&_logistics/urban_transport",
  "/business_&_industrial/transportation_&_logistics/warehousing",
  "/computers_&_electronics",
  "/computers_&_electronics/cad_&_cam",
  "/computers_&_electronics/computer_hardware",
  "/computers_&_electronics/computer_hardware/computer_components",
  "/computers_&_electronics/computer_hardware/computer_drives_&_storage",
  "/computers_&_electronics/computer_hardware/computer_peripherals",
  "/computers_&_electronics/computer_hardware/computer_servers",
  "/computers_&_electronics/computer_hardware/desktop_computers",
  "/computers_&_electronics/computer_hardware/hardware_modding_&_tuning",
  "/computers_&_electronics/computer_hardware/laptops_&_notebooks",
  "/computers_&_electronics/computer_security",
  "/computers_&_electronics/computer_security/antivirus_&_malware",
  "/computers_&_electronics/computer_security/hacking_&_cracking",
  "/computers_&_electronics/computer_security/network_security",
  "/computers_&_electronics/consumer_electronics",
  "/computers_&_electronics/consumer_electronics/audio_equipment",
  "/computers_&_electronics/consumer_electronics/camera_&_photo_equipment",
  "/computers_&_electronics/consumer_electronics/car_electronics",
  "/computers_&_electronics/consumer_electronics/drones_&_rc_aircraft",
  "/computers_&_electronics/consumer_electronics/electronic_accessories",
  "/computers_&_electronics/consumer_electronics/gadgets_&_portable_electronics",
  "/computers_&_electronics/consumer_electronics/game_systems_&_consoles",
  "/computers_&_electronics/consumer_electronics/gps_&_navigation",
  "/computers_&_electronics/consumer_electronics/home_automation",
  "/computers_&_electronics/consumer_electronics/media_streaming_devices",
  "/computers_&_electronics/consumer_electronics/tv_&_video_equipment",
  "/computers_&_electronics/consumer_electronics/virtual_reality_devices",
  "/computers_&_electronics/electronics_&_electrical",
  "/computers_&_electronics/electronics_&_electrical/data_sheets_&_electronics_reference",
  "/computers_&_electronics/electronics_&_electrical/electrical_test_&_measurement",
  "/computers_&_electronics/electronics_&_electrical/electromechanical_devices",
  "/computers_&_electronics/electronics_&_electrical/electronic_components",
  "/computers_&_electronics/electronics_&_electrical/optoelectronics_&_fiber",
  "/computers_&_electronics/electronics_&_electrical/power_supplies",
  "/computers_&_electronics/enterprise_technology",
  "/computers_&_electronics/enterprise_technology/customer_relationship_management_(crm)",
  "/computers_&_electronics/enterprise_technology/data_management",
  "/computers_&_electronics/enterprise_technology/enterprise_resource_planning_(erp)",
  "/computers_&_electronics/enterprise_technology/helpdesk_&_customer_support_systems",
  "/computers_&_electronics/networking",
  "/computers_&_electronics/networking/data_formats_&_protocols",
  "/computers_&_electronics/networking/distributed_&_cloud_computing",
  "/computers_&_electronics/networking/network_monitoring_&_management",
  "/computers_&_electronics/networking/networking_equipment",
  "/computers_&_electronics/networking/vpn_&_remote_access",
  "/computers_&_electronics/programming",
  "/computers_&_electronics/programming/c_&_c++",
  "/computers_&_electronics/programming/development_tools",
  "/computers_&_electronics/programming/java_(programming_language)",
  "/computers_&_electronics/programming/scripting_languages",
  "/computers_&_electronics/programming/windows_&_.net",
  "/computers_&_electronics/software",
  "/computers_&_electronics/software/business_&_productivity_software",
  "/computers_&_electronics/software/device_drivers",
  "/computers_&_electronics/software/educational_software",
  "/computers_&_electronics/software/freeware_&_shareware",
  "/computers_&_electronics/software/intelligent_personal_assistants",
  "/computers_&_electronics/software/internet_software",
  "/computers_&_electronics/software/monitoring_software",
  "/computers_&_electronics/software/multimedia_software",
  "/computers_&_electronics/software/open_source",
  "/computers_&_electronics/software/operating_systems",
  "/computers_&_electronics/software/software_utilities",
  "/finance",
  "/finance/accounting_&_auditing",
  "/finance/accounting_&_auditing/billing_&_invoicing",
  "/finance/accounting_&_auditing/bookkeeping",
  "/finance/accounting_&_auditing/tax_preparation_&_planning",
  "/finance/banking",
  "/finance/banking/atms_&_branch_locations",
  "/finance/banking/debit_&_checking_services",
  "/finance/banking/mobile_payments_&_digital_wallets",
  "/finance/banking/money_transfer_&_wire_services",
  "/finance/banking/savings_accounts",
  "/finance/credit_&_lending",
  "/finance/credit_&_lending/credit_cards",
  "/finance/credit_&_lending/credit_reporting_&_monitoring",
  "/finance/credit_&_lending/debt_collection_&_repossession",
  "/finance/credit_&_lending/debt_management",
  "/finance/credit_&_lending/loans",
  "/finance/crowdfunding",
  "/finance/financial_planning_&_management",
  "/finance/financial_planning_&_management/asset_&_portfolio_management",
  "/finance/financial_planning_&_management/inheritance_&_estate_planning",
  "/finance/financial_planning_&_management/retirement_&_pension",
  "/finance/grants_scholarships_&_financial_aid",
  "/finance/grants_scholarships_&_financial_aid/government_grants",
  "/finance/grants_scholarships_&_financial_aid/study_grants_&_scholarships",
  "/finance/insurance",
  "/finance/insurance/health_insurance",
  "/finance/insurance/home_insurance",
  "/finance/insurance/life_insurance",
  "/finance/insurance/travel_insurance",
  "/finance/insurance/vehicle_insurance",
  "/finance/investing",
  "/finance/investing/brokerages_&_day_trading",
  "/finance/investing/commodities_&_futures_trading",
  "/finance/investing/currencies_&_foreign_exchange",
  "/finance/investing/derivatives",
  "/finance/investing/funds",
  "/finance/investing/real_estate_investment_trusts",
  "/finance/investing/socially_responsible_investing",
  "/finance/investing/stocks_&_bonds",
  "/food_&_drink",
  "/food_&_drink/beverages",
  "/food_&_drink/beverages/alcohol-free_beverages",
  "/food_&_drink/beverages/alcoholic_beverages",
  "/food_&_drink/beverages/bottled_water",
  "/food_&_drink/beverages/coffee_&_tea",
  "/food_&_drink/beverages/energy_drinks",
  "/food_&_drink/beverages/juice",
  "/food_&_drink/beverages/nutrition_drinks_&_shakes",
  "/food_&_drink/beverages/soft_drinks",
  "/food_&_drink/beverages/sports_drinks",
  "/food_&_drink/cooking_&_recipes",
  "/food_&_drink/cooking_&_recipes/bbq_&_grilling",
  "/food_&_drink/cooking_&_recipes/cuisines",
  "/food_&_drink/cooking_&_recipes/culinary_training",
  "/food_&_drink/cooking_&_recipes/desserts",
  "/food_&_drink/cooking_&_recipes/healthy_eating",
  "/food_&_drink/cooking_&_recipes/salads",
  "/food_&_drink/cooking_&_recipes/soups_&_stews",
  "/food_&_drink/food_&_grocery_delivery",
  "/food_&_drink/food_&_grocery_delivery/grocery_delivery_services",
  "/food_&_drink/food_&_grocery_delivery/meal_kits",
  "/food_&_drink/food_&_grocery_delivery/restaurant_delivery_services",
  "/food_&_drink/food_&_grocery_retailers",
  "/food_&_drink/food_&_grocery_retailers/bakeries",
  "/food_&_drink/food_&_grocery_retailers/butchers",
  "/food_&_drink/food_&_grocery_retailers/convenience_stores",
  "/food_&_drink/food_&_grocery_retailers/delicatessens",
  "/food_&_drink/food_&_grocery_retailers/farmers_markets",
  "/food_&_drink/food_&_grocery_retailers/farmers'_markets",
  "/food_&_drink/food",
  "/food_&_drink/food/baked_goods",
  "/food_&_drink/food/breakfast_foods",
  "/food_&_drink/food/candy_&_sweets",
  "/food_&_drink/food/condiments_&_dressings",
  "/food_&_drink/food/cooking_fats_&_oils",
  "/food_&_drink/food/dairy_&_egg_substitutes",
  "/food_&_drink/food/dairy_&_eggs",
  "/food_&_drink/food/fruits_&_vegetables",
  "/food_&_drink/food/gourmet_&_specialty_foods",
  "/food_&_drink/food/grains_&_pasta",
  "/food_&_drink/food/herbs_&_spices",
  "/food_&_drink/food/jams_jellies_&_preserves",
  "/food_&_drink/food/meat_&_seafood_substitutes",
  "/food_&_drink/food/meat_&_seafood",
  "/food_&_drink/food/organic_&_natural_foods",
  "/food_&_drink/food/snack_foods",
  "/food_&_drink/restaurants",
  "/food_&_drink/restaurants/catering",
  "/food_&_drink/restaurants/dining_guides",
  "/food_&_drink/restaurants/fast_food",
  "/food_&_drink/restaurants/fine_dining",
  "/food_&_drink/restaurants/pizzerias",
  "/games",
  "/games/arcade_&_coin-op_games",
  "/games/board_games",
  "/games/board_games/chess_&_abstract_strategy_games",
  "/games/board_games/miniatures_&_wargaming",
  "/games/card_games",
  "/games/card_games/collectible_card_games",
  "/games/computer_&_video_games",
  "/games/computer_&_video_games/action_&_platform_games",
  "/games/computer_&_video_games/adventure_games",
  "/games/computer_&_video_games/browser_games",
  "/games/computer_&_video_games/casual_games",
  "/games/computer_&_video_games/competitive_video_gaming",
  "/games/computer_&_video_games/driving_&_racing_games",
  "/games/computer_&_video_games/fighting_games",
  "/games/computer_&_video_games/gaming_media_&_reference",
  "/games/computer_&_video_games/music_&_dance_games",
  "/games/computer_&_video_games/sandbox_games",
  "/games/computer_&_video_games/shooter_games",
  "/games/computer_&_video_games/simulation_games",
  "/games/computer_&_video_games/sports_games",
  "/games/computer_&_video_games/strategy_games",
  "/games/computer_&_video_games/video_game_development",
  "/games/computer_&_video_games/video_game_emulation",
  "/games/computer_&_video_games/video_game_mods_&_add-ons",
  "/games/computer_&_video_games/video_game_retailers",
  "/games/dice_games",
  "/games/educational_games",
  "/games/family-oriented_games_&_activities",
  "/games/family-oriented_games_&_activities/drawing_&_coloring",
  "/games/family-oriented_games_&_activities/dress-up_&_fashion_games",
  "/games/online_games",
  "/games/online_games/massive_multiplayer",
  "/games/party_games",
  "/games/puzzles_&_brainteasers",
  "/games/roleplaying_games",
  "/games/table_games",
  "/games/table_games/billiards",
  "/games/table_games/table_tennis",
  "/games/tile_games",
  "/games/word_games",
  "/health",
  "/health/aging_&_geriatrics",
  "/health/alternative_&_natural_medicine",
  "/health/alternative_&_natural_medicine/acupuncture_&_chinese_medicine",
  "/health/alternative_&_natural_medicine/cleansing_&_detoxification",
  "/health/health_conditions",
  "/health/health_conditions/allergies",
  "/health/health_conditions/cold_&_flu",
  "/health/health_conditions/ear_nose_&_throat",
  "/health/health_education_&_medical_training",
  "/health/health_foundations_&_medical_research",
  "/health/medical_devices_&_equipment",
  "/health/medical_devices_&_equipment/assistive_technology",
  "/health/medical_facilities_&_services",
  "/health/medical_facilities_&_services/doctors'_offices",
  "/health/medical_facilities_&_services/hospitals_&_treatment_centers",
  "/health/medical_facilities_&_services/medical_procedures",
  "/health/medical_facilities_&_services/physical_therapy",
  "/health/medical_literature_&_resources",
  "/health/medical_literature_&_resources/medical_photos_&_illustration",
  "/health/men's_health",
  "/health/mens_health",
  "/health/mental_health",
  "/health/nursing",
  "/health/nursing/assisted_living_&_long_term_care",
  "/health/nutrition",
  "/health/nutrition/special_&_restricted_diets",
  "/health/nutrition/vitamins_&_supplements",
  "/health/oral_&_dental_care",
  "/health/pediatrics",
  "/health/pharmacy",
  "/health/public_health",
  "/health/public_health/health_policy",
  "/health/public_health/occupational_health_&_safety",
  "/health/public_health/toxic_substances_&_poisoning",
  "/health/vision_care",
  "/health/vision_care/eye_exams_&_optometry",
  "/health/vision_care/eyeglasses_&_contacts",
  "/health/vision_care/laser_vision_correction",
  "/health/women's_health",
  "/health/womens_health",
  "/hobbies_&_leisure",
  "/hobbies_&_leisure/clubs_&_organizations",
  "/hobbies_&_leisure/clubs_&_organizations/fraternal_orders_&_service_clubs",
  "/hobbies_&_leisure/clubs_&_organizations/youth_organizations_&_resources",
  "/hobbies_&_leisure/contests_awards_&_prizes",
  "/hobbies_&_leisure/crafts",
  "/hobbies_&_leisure/crafts/ceramics_&_pottery",
  "/hobbies_&_leisure/crafts/fiber_&_textile_arts",
  "/hobbies_&_leisure/outdoors",
  "/hobbies_&_leisure/outdoors/equestrian",
  "/hobbies_&_leisure/outdoors/fishing",
  "/hobbies_&_leisure/outdoors/hiking_&_camping",
  "/hobbies_&_leisure/outdoors/hunting_&_shooting",
  "/hobbies_&_leisure/paintball",
  "/hobbies_&_leisure/radio_control_&_modeling",
  "/hobbies_&_leisure/radio_control_&_modeling/model_trains_&_railroads",
  "/hobbies_&_leisure/recreational_aviation",
  "/hobbies_&_leisure/special_occasions",
  "/hobbies_&_leisure/special_occasions/anniversaries",
  "/hobbies_&_leisure/special_occasions/holidays_&_seasonal_events",
  "/hobbies_&_leisure/special_occasions/weddings",
  "/hobbies_&_leisure/sweepstakes_&_promotional_giveaways",
  "/hobbies_&_leisure/water_activities",
  "/hobbies_&_leisure/water_activities/boating",
  "/hobbies_&_leisure/water_activities/diving_&_underwater_activities",
  "/hobbies_&_leisure/water_activities/surf_&_swim",
  "/home_&_garden",
  "/home_&_garden/bed_&_bath",
  "/home_&_garden/bed_&_bath/bathroom",
  "/home_&_garden/bed_&_bath/bedroom",
  "/home_&_garden/domestic_services",
  "/home_&_garden/domestic_services/cleaning_services",
  "/home_&_garden/domestic_services/cleaning_supplies_&_services",
  "/home_&_garden/gardening_&_landscaping",
  "/home_&_garden/gardening_&_landscaping/garden_structures",
  "/home_&_garden/gardening_&_landscaping/gardening",
  "/home_&_garden/gardening_&_landscaping/landscaping",
  "/home_&_garden/home_appliances",
  "/home_&_garden/home_appliances/vacuums_&_floor_care",
  "/home_&_garden/home_appliances/water_filters_&_purifiers",
  "/home_&_garden/home_furnishings",
  "/home_&_garden/home_furnishings/clocks",
  "/home_&_garden/home_furnishings/countertops",
  "/home_&_garden/home_furnishings/curtains_&_window_treatments",
  "/home_&_garden/home_furnishings/kitchen_&_dining_furniture",
  "/home_&_garden/home_furnishings/lamps_&_lighting",
  "/home_&_garden/home_furnishings/living_room_furniture",
  "/home_&_garden/home_furnishings/outdoor_furniture",
  "/home_&_garden/home_furnishings/rugs_&_carpets",
  "/home_&_garden/home_furnishings/sofas_&_chairs",
  "/home_&_garden/home_improvement",
  "/home_&_garden/home_improvement/construction_&_power_tools",
  "/home_&_garden/home_improvement/doors_&_windows",
  "/home_&_garden/home_improvement/flooring",
  "/home_&_garden/home_improvement/house_painting_&_finishing",
  "/home_&_garden/home_improvement/locks_&_locksmiths",
  "/home_&_garden/home_improvement/plumbing",
  "/home_&_garden/home_improvement/roofing",
  "/home_&_garden/home_safety_&_security",
  "/home_&_garden/home_safety_&_security/home_alarm_&_security_systems",
  "/home_&_garden/home_storage_&_shelving",
  "/home_&_garden/home_storage_&_shelving/cabinetry",
  "/home_&_garden/homemaking_&_interior_decor",
  "/home_&_garden/household_supplies",
  "/home_&_garden/household_supplies/household_batteries",
  "/home_&_garden/household_supplies/household_cleaning_supplies",
  "/home_&_garden/hvac_&_climate_control",
  "/home_&_garden/hvac_&_climate_control/air_conditioners",
  "/home_&_garden/hvac_&_climate_control/air_filters_&_purifiers",
  "/home_&_garden/hvac_&_climate_control/fireplaces_&_stoves",
  "/home_&_garden/hvac_&_climate_control/heaters",
  "/home_&_garden/hvac_&_climate_control/household_fans",
  "/home_&_garden/kitchen_&_dining",
  "/home_&_garden/kitchen_&_dining/cookware_&_diningware",
  "/home_&_garden/kitchen_&_dining/major_kitchen_appliances",
  "/home_&_garden/kitchen_&_dining/small_kitchen_appliances",
  "/home_&_garden/laundry",
  "/home_&_garden/laundry/washers_&_dryers",
  "/home_&_garden/nursery_&_playroom",
  "/home_&_garden/pest_control",
  "/home_&_garden/swimming_pools_&_spas",
  "/home_&_garden/yard_&_patio",
  "/home_&_garden/yard_&_patio/barbecues_&_grills",
  "/home_&_garden/yard_&_patio/lawn_mowers",
  "/internet_&_telecom",
  "/internet_&_telecom/communications_equipment",
  "/internet_&_telecom/communications_equipment/radio_equipment",
  "/internet_&_telecom/email_&_messaging",
  "/internet_&_telecom/email_&_messaging/email",
  "/internet_&_telecom/email_&_messaging/spam_&_email_filtering",
  "/internet_&_telecom/email_&_messaging/text_&_instant_messaging",
  "/internet_&_telecom/email_&_messaging/voice_&_video_chat",
  "/internet_&_telecom/mobile_&_wireless",
  "/internet_&_telecom/mobile_&_wireless/mobile_&_wireless_accessories",
  "/internet_&_telecom/mobile_&_wireless/mobile_apps_&_add-ons",
  "/internet_&_telecom/mobile_&_wireless/mobile_phones",
  "/internet_&_telecom/search_engines",
  "/internet_&_telecom/search_engines/people_search",
  "/internet_&_telecom/service_providers",
  "/internet_&_telecom/service_providers/cable_&_satellite_providers",
  "/internet_&_telecom/service_providers/internet_cafes",
  "/internet_&_telecom/service_providers/isps",
  "/internet_&_telecom/service_providers/phone_service_providers",
  "/internet_&_telecom/teleconferencing",
  "/internet_&_telecom/web_apps_&_online_tools",
  "/internet_&_telecom/web_portals",
  "/internet_&_telecom/web_services",
  "/internet_&_telecom/web_services/affiliate_programs",
  "/internet_&_telecom/web_services/hosted_data_storage",
  "/internet_&_telecom/web_services/search_engine_optimization_&_marketing",
  "/internet_&_telecom/web_services/web_design_&_development",
  "/internet_&_telecom/web_services/web_hosting_&_domain_registration",
  "/internet_&_telecom/web_services/web_stats_&_analytics",
  "/jobs_&_education",
  "/jobs_&_education/education",
  "/jobs_&_education/education/academic_conferences_&_publications",
  "/jobs_&_education/education/alumni_&_reunions",
  "/jobs_&_education/education/colleges_&_universities",
  "/jobs_&_education/education/computer_education",
  "/jobs_&_education/education/distance_learning",
  "/jobs_&_education/education/early_childhood_education",
  "/jobs_&_education/education/homeschooling",
  "/jobs_&_education/education/open_online_courses",
  "/jobs_&_education/education/primary_&_secondary_schooling_(k-12)",
  "/jobs_&_education/education/private_tutoring_services",
  "/jobs_&_education/education/special_education",
  "/jobs_&_education/education/standardized_&_admissions_tests",
  "/jobs_&_education/education/study_abroad",
  "/jobs_&_education/education/teaching_&_classroom_resources",
  "/jobs_&_education/education/training_&_certification",
  "/jobs_&_education/education/vocational_&_continuing_education",
  "/jobs_&_education/internships",
  "/jobs_&_education/jobs",
  "/jobs_&_education/jobs/career_resources_&_planning",
  "/jobs_&_education/jobs/job_listings",
  "/jobs_&_education/jobs/resumes_&_portfolios",
  "/law_&_government",
  "/law_&_government/government",
  "/law_&_government/government/courts_&_judiciary",
  "/law_&_government/government/embassies_&_consulates",
  "/law_&_government/government/executive_branch",
  "/law_&_government/government/government_agencies",
  "/law_&_government/government/government_contracting_&_procurement",
  "/law_&_government/government/intelligence_&_counterterrorism",
  "/law_&_government/government/legislative_branch",
  "/law_&_government/government/lobbying",
  "/law_&_government/government/multilateral_organizations",
  "/law_&_government/government/public_finance",
  "/law_&_government/government/public_policy",
  "/law_&_government/government/royalty",
  "/law_&_government/government/state_&_local_government",
  "/law_&_government/government/visa_&_immigration",
  "/law_&_government/legal",
  "/law_&_government/legal/accident_&_personal_injury_law",
  "/law_&_government/legal/bankruptcy",
  "/law_&_government/legal/business_&_corporate_law",
  "/law_&_government/legal/constitutional_law_&_civil_rights",
  "/law_&_government/legal/criminal_law",
  "/law_&_government/legal/family_law",
  "/law_&_government/legal/intellectual_property",
  "/law_&_government/legal/labor_&_employment_law",
  "/law_&_government/legal/legal_education",
  "/law_&_government/legal/legal_services",
  "/law_&_government/legal/product_liability",
  "/law_&_government/legal/real_estate_law",
  "/law_&_government/military",
  "/law_&_government/military/air_force",
  "/law_&_government/military/army",
  "/law_&_government/military/marines",
  "/law_&_government/military/navy",
  "/law_&_government/military/veterans",
  "/law_&_government/public_safety",
  "/law_&_government/public_safety/crime_&_justice",
  "/law_&_government/public_safety/emergency_services",
  "/law_&_government/public_safety/law_enforcement",
  "/law_&_government/public_safety/security_products_&_services",
  "/law_&_government/social_services",
  "/law_&_government/social_services/welfare_&_unemployment",
  "/news",
  "/news/broadcast_&_network_news",
  "/news/business_news",
  "/news/business_news/company_news",
  "/news/business_news/economy_news",
  "/news/business_news/financial_markets",
  "/news/business_news/fiscal_policy_news",
  "/news/gossip_&_tabloid_news",
  "/news/gossip_&_tabloid_news/scandals_&_investigations",
  "/news/health_news",
  "/news/journalism_&_news_industry",
  "/news/local_news",
  "/news/newspapers",
  "/news/politics",
  "/news/politics/campaigns_&_elections",
  "/news/politics/media_critics_&_watchdogs",
  "/news/politics/opinion_&_commentary",
  "/news/politics/political_polls_&_surveys",
  "/news/sports_news",
  "/news/technology_news",
  "/news/weather",
  "/news/world_news",
  "/online_communities",
  "/online_communities/blogging_resources_&_services",
  "/online_communities/blogging_resources_&_services/microblogging",
  "/online_communities/dating_&_personals",
  "/online_communities/dating_&_personals/matrimonial_services",
  "/online_communities/dating_&_personals/personals",
  "/online_communities/feed_aggregation_&_social_bookmarking",
  "/online_communities/file_sharing_&_hosting",
  "/online_communities/forum_&_chat_providers",
  "/online_communities/online_goodies",
  "/online_communities/online_goodies/clip_art_&_animated_gifs",
  "/online_communities/online_goodies/skins_themes_&_wallpapers",
  "/online_communities/online_goodies/social_network_apps_&_add-ons",
  "/online_communities/online_journals_&_personal_sites",
  "/online_communities/photo_&_video_sharing",
  "/online_communities/photo_&_video_sharing/photo_&_image_sharing",
  "/online_communities/photo_&_video_sharing/video_sharing",
  "/online_communities/social_networks",
  "/online_communities/virtual_worlds",
  "/people_&_society",
  "/people_&_society/family_&_relationships",
  "/people_&_society/family_&_relationships/etiquette",
  "/people_&_society/family_&_relationships/family",
  "/people_&_society/family_&_relationships/friendship",
  "/people_&_society/family_&_relationships/marriage",
  "/people_&_society/family_&_relationships/romance",
  "/people_&_society/family_&_relationships/troubled_relationships",
  "/people_&_society/kids_&_teens",
  "/people_&_society/kids_&_teens/childrens_interests",
  "/people_&_society/kids_&_teens/teen_interests",
  "/people_&_society/religion_&_belief",
  "/people_&_society/religion_&_belief/self-help_&_motivational",
  "/people_&_society/seniors_&_retirement",
  "/people_&_society/social_issues_&_advocacy",
  "/people_&_society/social_issues_&_advocacy/charity_&_philanthropy",
  "/people_&_society/social_issues_&_advocacy/discrimination_&_identity_relations",
  "/people_&_society/social_issues_&_advocacy/drug_laws_&_policy",
  "/people_&_society/social_issues_&_advocacy/ethics",
  "/people_&_society/social_issues_&_advocacy/green_living_&_environmental_issues",
  "/people_&_society/social_issues_&_advocacy/housing_&_development",
  "/people_&_society/social_issues_&_advocacy/human_rights_&_liberties",
  "/people_&_society/social_issues_&_advocacy/immigration_policy_&_border_issues",
  "/people_&_society/social_issues_&_advocacy/poverty_&_hunger",
  "/people_&_society/social_issues_&_advocacy/privacy_issues",
  "/people_&_society/social_issues_&_advocacy/same-sex_marriage",
  "/people_&_society/social_issues_&_advocacy/work_&_labor_issues",
  "/people_&_society/social_sciences",
  "/people_&_society/social_sciences/anthropology",
  "/people_&_society/social_sciences/archaeology",
  "/people_&_society/social_sciences/communications_&_media_studies",
  "/people_&_society/social_sciences/demographics",
  "/people_&_society/social_sciences/economics",
  "/people_&_society/social_sciences/international_relations",
  "/people_&_society/social_sciences/political_science",
  "/people_&_society/social_sciences/psychology",
  "/people_&_society/subcultures_&_niche_interests",
  "/people_&_society/subcultures_&_niche_interests/goth_subculture",
  "/people_&_society/subcultures_&_niche_interests/science_fiction_&_fantasy",
  "/pets_&_animals",
  "/pets_&_animals/animal_products_&_services",
  "/pets_&_animals/animal_products_&_services/animal_welfare",
  "/pets_&_animals/animal_products_&_services/pet_food_&_supplies",
  "/pets_&_animals/animal_products_&_services/veterinarians",
  "/pets_&_animals/pets",
  "/pets_&_animals/pets/birds",
  "/pets_&_animals/pets/cats",
  "/pets_&_animals/pets/dogs",
  "/pets_&_animals/pets/exotic_pets",
  "/pets_&_animals/pets/fish_&_aquaria",
  "/pets_&_animals/pets/horses",
  "/pets_&_animals/pets/rabbits_&_rodents",
  "/pets_&_animals/pets/reptiles_&_amphibians",
  "/pets_&_animals/wildlife",
  "/real_estate",
  "/real_estate/apartments_&_residential_rentals",
  "/real_estate/bank-owned_&_foreclosed_properties",
  "/real_estate/property_development",
  "/real_estate/property_inspections_&_appraisals",
  "/real_estate/real_estate_agencies",
  "/real_estate/real_estate_listings",
  "/real_estate/real_estate_listings/commercial_properties",
  "/real_estate/real_estate_listings/lots_&_land",
  "/real_estate/real_estate_listings/residential_sales",
  "/real_estate/real_estate_services",
  "/real_estate/real_estate_services/property_management",
  "/real_estate/real_estate_services/real_estate_title_&_escrow",
  "/real_estate/timeshares_&_vacation_properties",
  "/reference",
  "/reference/directories_&_listings",
  "/reference/directories_&_listings/business_&_personal_listings",
  "/reference/general_reference",
  "/reference/general_reference/biographies_&_quotations",
  "/reference/general_reference/calculators_&_reference_tools",
  "/reference/general_reference/dictionaries_&_encyclopedias",
  "/reference/general_reference/educational_resources",
  "/reference/general_reference/forms_guides_&_templates",
  "/reference/general_reference/how-to_diy_&_expert_content",
  "/reference/general_reference/public_records",
  "/reference/general_reference/time_&_calendars",
  "/reference/geographic_reference",
  "/reference/geographic_reference/city_&_local_guides",
  "/reference/geographic_reference/maps",
  "/reference/humanities",
  "/reference/humanities/history",
  "/reference/humanities/myth_&_folklore",
  "/reference/humanities/philosophy",
  "/reference/language_resources",
  "/reference/language_resources/foreign_language_resources",
  "/reference/libraries_&_museums",
  "/reference/libraries_&_museums/libraries",
  "/reference/libraries_&_museums/museums",
  "/reference/technical_reference",
  "/science",
  "/science/astronomy",
  "/science/biological_sciences",
  "/science/biological_sciences/anatomy",
  "/science/biological_sciences/flora_&_fauna",
  "/science/biological_sciences/genetics",
  "/science/biological_sciences/neuroscience",
  "/science/chemistry",
  "/science/computer_science",
  "/science/computer_science/distributed_&_parallel_computing",
  "/science/computer_science/machine_learning_&_artificial_intelligence",
  "/science/earth_sciences",
  "/science/earth_sciences/atmospheric_science",
  "/science/earth_sciences/geology",
  "/science/earth_sciences/paleontology",
  "/science/earth_sciences/water_&_marine_sciences",
  "/science/ecology_&_environment",
  "/science/ecology_&_environment/climate_change_&_global_warming",
  "/science/engineering_&_technology",
  "/science/engineering_&_technology/augmented_&_virtual_reality",
  "/science/engineering_&_technology/robotics",
  "/science/mathematics",
  "/science/mathematics/statistics",
  "/science/physics",
  "/science/scientific_equipment",
  "/science/scientific_institutions",
  "/sensitive_subjects",
  "/sensitive_subjects/accidents_&_disasters",
  "/sensitive_subjects/death_&_tragedy",
  "/sensitive_subjects/war_&_conflict",
  "/shopping",
  "/shopping/antiques_&_collectibles",
  "/shopping/apparel",
  "/shopping/apparel/apparel_services",
  "/shopping/apparel/athletic_apparel",
  "/shopping/apparel/casual_apparel",
  "/shopping/apparel/children's_clothing",
  "/shopping/apparel/childrens_clothing",
  "/shopping/apparel/clothing_accessories",
  "/shopping/apparel/costumes",
  "/shopping/apparel/eyewear",
  "/shopping/apparel/footwear",
  "/shopping/apparel/formal_wear",
  "/shopping/apparel/headwear",
  "/shopping/apparel/men's_clothing",
  "/shopping/apparel/mens_clothing",
  "/shopping/apparel/outerwear",
  "/shopping/apparel/pants_&_shorts",
  "/shopping/apparel/shirts_&_tops",
  "/shopping/apparel/sleepwear",
  "/shopping/apparel/suits_&_business_attire",
  "/shopping/apparel/swimwear",
  "/shopping/apparel/undergarments",
  "/shopping/apparel/uniforms_&_workwear",
  "/shopping/apparel/women's_clothing",
  "/shopping/apparel/womens_clothing",
  "/shopping/auctions",
  "/shopping/classifieds",
  "/shopping/consumer_resources",
  "/shopping/consumer_resources/consumer_advocacy_&_protection",
  "/shopping/consumer_resources/coupons_&_discount_offers",
  "/shopping/consumer_resources/customer_services",
  "/shopping/consumer_resources/identity_theft_&_protection",
  "/shopping/consumer_resources/product_reviews_&_price_comparisons",
  "/shopping/discount_&_outlet_stores",
  "/shopping/entertainment_media",
  "/shopping/entertainment_media/entertainment_media_rentals",
  "/shopping/gifts_&_special_event_items",
  "/shopping/gifts_&_special_event_items/cards_&_greetings",
  "/shopping/gifts_&_special_event_items/custom_&_personalized_items",
  "/shopping/gifts_&_special_event_items/flowers",
  "/shopping/gifts_&_special_event_items/gifts",
  "/shopping/gifts_&_special_event_items/party_&_holiday_supplies",
  "/shopping/green_&_eco-friendly_shopping",
  "/shopping/luxury_goods",
  "/shopping/mass_merchants_&_department_stores",
  "/shopping/photo_&_video_services",
  "/shopping/photo_&_video_services/event_&_studio_photography",
  "/shopping/photo_&_video_services/photo_printing_services",
  "/shopping/photo_&_video_services/stock_photography",
  "/shopping/shopping_portals",
  "/shopping/swap_meets_&_outdoor_markets",
  "/shopping/toys",
  "/shopping/toys/action_figures",
  "/shopping/toys/building_toys",
  "/shopping/toys/die-cast_&_toy_vehicles",
  "/shopping/toys/dolls_&_accessories",
  "/shopping/toys/educational_toys",
  "/shopping/toys/outdoor_toys_&_play_equipment",
  "/shopping/toys/puppets",
  "/shopping/toys/ride-on_toys_&_wagons",
  "/shopping/toys/stuffed_toys",
  "/shopping/wholesalers_&_liquidators",
  "/sports",
  "/sports/animal_sports",
  "/sports/animal_sports/equestrian",
  "/sports/college_sports",
  "/sports/combat_sports",
  "/sports/combat_sports/boxing",
  "/sports/combat_sports/fencing",
  "/sports/combat_sports/martial_arts",
  "/sports/combat_sports/wrestling",
  "/sports/extreme_sports",
  "/sports/extreme_sports/climbing_&_mountaineering",
  "/sports/extreme_sports/drag_&_street_racing",
  "/sports/extreme_sports/stunts_&_dangerous_feats",
  "/sports/fantasy_sports",
  "/sports/individual_sports",
  "/sports/individual_sports/bowling",
  "/sports/individual_sports/cycling",
  "/sports/individual_sports/golf",
  "/sports/individual_sports/gymnastics",
  "/sports/individual_sports/racquet_sports",
  "/sports/individual_sports/running_&_walking",
  "/sports/individual_sports/skate_sports",
  "/sports/individual_sports/track_&_field",
  "/sports/motor_sports",
  "/sports/motor_sports/auto_racing",
  "/sports/motor_sports/motorcycle_racing",
  "/sports/sport_scores_&_statistics",
  "/sports/sporting_goods",
  "/sports/sporting_goods/american_football_equipment",
  "/sports/sporting_goods/baseball_equipment",
  "/sports/sporting_goods/basketball_equipment",
  "/sports/sporting_goods/bowling_equipment",
  "/sports/sporting_goods/combat_sports_equipment",
  "/sports/sporting_goods/cricket_equipment",
  "/sports/sporting_goods/electric_skateboards_&_scooters",
  "/sports/sporting_goods/equestrian_equipment_&_tack",
  "/sports/sporting_goods/golf_equipment",
  "/sports/sporting_goods/gymnastics_equipment",
  "/sports/sporting_goods/hockey_equipment",
  "/sports/sporting_goods/ice_skating_equipment",
  "/sports/sporting_goods/roller_skating_&_rollerblading_equipment",
  "/sports/sporting_goods/skateboarding_equipment",
  "/sports/sporting_goods/soccer_equipment",
  "/sports/sporting_goods/sports_memorabilia",
  "/sports/sporting_goods/squash_&_racquetball_equipment",
  "/sports/sporting_goods/table_tennis_equipment",
  "/sports/sporting_goods/tennis_equipment",
  "/sports/sporting_goods/volleyball_equipment",
  "/sports/sporting_goods/water_sports_equipment",
  "/sports/sporting_goods/winter_sports_equipment",
  "/sports/sports_coaching_&_training",
  "/sports/sports_fan_gear_&_apparel",
  "/sports/team_sports",
  "/sports/team_sports/american_football",
  "/sports/team_sports/australian_football",
  "/sports/team_sports/baseball",
  "/sports/team_sports/basketball",
  "/sports/team_sports/cheerleading",
  "/sports/team_sports/cricket",
  "/sports/team_sports/handball",
  "/sports/team_sports/hockey",
  "/sports/team_sports/rugby",
  "/sports/team_sports/soccer",
  "/sports/team_sports/volleyball",
  "/sports/water_sports",
  "/sports/water_sports/surfing",
  "/sports/water_sports/swimming",
  "/sports/winter_sports",
  "/sports/winter_sports/ice_skating",
  "/sports/winter_sports/skiing_&_snowboarding",
  "/sports/world_sports_competitions",
  "/sports/world_sports_competitions/olympics",
  "/travel",
  "/travel/air_travel",
  "/travel/air_travel/airport_parking_&_transportation",
  "/travel/bus_&_rail",
  "/travel/car_rental_&_taxi_services",
  "/travel/carpooling_&_vehicle_sharing",
  "/travel/cruises_&_charters",
  "/travel/hotels_&_accommodations",
  "/travel/hotels_&_accommodations/vacation_rentals_&_short-term_stays",
  "/travel/luggage_&_travel_accessories",
  "/travel/luggage_&_travel_accessories/backpacks_&_utility_bags",
  "/travel/specialty_travel",
  "/travel/specialty_travel/adventure_travel",
  "/travel/specialty_travel/agritourism",
  "/travel/specialty_travel/business_travel",
  "/travel/specialty_travel/ecotourism",
  "/travel/specialty_travel/family_travel",
  "/travel/specialty_travel/honeymoons_&_romantic_getaways",
  "/travel/specialty_travel/low_cost_&_last_minute_travel",
  "/travel/specialty_travel/luxury_travel",
  "/travel/specialty_travel/medical_tourism",
  "/travel/specialty_travel/religious_travel",
  "/travel/specialty_travel/sightseeing_tours",
  "/travel/specialty_travel/vineyards_&_wine_tourism",
  "/travel/tourist_destinations",
  "/travel/tourist_destinations/beaches_&_islands",
  "/travel/tourist_destinations/historical_sites_&_buildings",
  "/travel/tourist_destinations/lakes_&_rivers",
  "/travel/tourist_destinations/mountain_&_ski_resorts",
  "/travel/tourist_destinations/regional_parks_&_gardens",
  "/travel/tourist_destinations/theme_parks",
  "/travel/tourist_destinations/zoos-aquariums-preserves",
  "/travel/transportation",
  "/travel/transportation/chartered_transportation_rentals",
  "/travel/transportation/scooter_&_bike_rentals",
  "/travel/transportation/taxi_&_ride_hail_services",
  "/travel/transportation/traffic_&_route_planners",
  "/travel/transportation/urban_transit",
  "/travel/travel_agencies_&_services",
  "/travel/travel_agencies_&_services/guided_tours_&_escorted_vacations",
  "/travel/travel_agencies_&_services/tourist_boards_&_visitor_centers",
  "/travel/travel_agencies_&_services/vacation_offers",
  "/travel/travel_guides_&_travelogues",
]

export default PREDICTORS_VALUES